import hybrid from "@/assets/js/common/hybrid/hybrid_wk.js";
import {debug} from "@/assets/js/common/fn/message";
const formatRes = (res) => {
    res = res || {};
    let { errno=0, data={}, msg="" } = res;
    return {
        errno : errno,
        data : data,
        msg : msg,
    };
};

const formatRes2 = (res) => {
    res = res || {};
    let { code=200, data={}, message="ok" } = res;
    return {
        code : code,
        data : data,
        message : message,
    };
};
//获取cookie
export const login_result = (req) => {
    hybrid({
        tagname : "login_result",
        callback: (res) => {
            req.callback(formatRes(res));
        }
    });
};

//
export const finish = () => {
    hybrid({tagname : "finish"});
};

/*
param: {
    pay_info: JSON.stringify(obj),
    track_info: track_info,
    good_id: good_id,
    good_type: 0, //0-kkb 1-vip
    pay_source: 2, //活动页
    from_page:'KK币半屏弹窗页',//会员半屏弹窗页，KKB半屏弹窗页。（不需要半屏弹窗时传空""）
}
*/
export const h5directpay = (req) => {
    hybrid({
        tagname: "h5directpay",
        param: req.data,
        callback: res => {
            res = res || {};
            let { code=200, data={}, message="ok" } = res;
            
            if (code == 200) {
                // 1: 支付成功 2: 支付失败 3:取消 4. 好友代付 5.没有找到对应的商品 6.好友代付回退
                switch(data.pay_status) {
                case 1:
                    message = "支付成功";
                    break;
                case 2:
                    message = "支付失败";
                    break;
                case 3:
                    message = "取消";
                    break;
                case 4:
                    message = "好友代付";
                    break;
                case 5:
                    message = "没有找到对应商品";
                    break;
                case 6:
                    message = "好友代付回退";
                    break;
                }
            }

            req.callback({
                code : code,
                data : data,
                message : message,
            });
        },
        is_del_nativecallback:false
    });
};

export const popLogin = (req) => {
    logout({
        callback : (res) => {
            login_win({
                callback : (res) => {
                    let { errno=0, data={}, msg="" } = res;
                    if (data.status == 0) { //未登录
                        req.callback_notloggedin && req.callback_notloggedin(formatRes(res));
                    }
                    if (data.status == 1) { //已登陆

                        req.callback_loggedin && req.callback_loggedin(formatRes(res));
                    }
                }
            });
        }
    });
};
//
export const refreshPayPage = (req) => {
    hybrid({
        tagname : "refreshPayPage",
        param   : {
            refresh: true
        },
        callback: (res) => {
        }
    });
};
//
export const logout = (req) => {
    hybrid({
        tagname : "logout",
        callback: (res) => {
            req.callback(formatRes(res));
        }
    });
};
//
export const login_win = (req) => {
    hybrid({
        tagname : "login_win",
        callback: (res) => {
            req.callback(formatRes(res));
        }
    });
};
// forward_h5({
//     param: {
//         totype: 'h5',
//         topage: 'www.kuaikanmanhua.com',
//         todata: {},
//     },
//     callback : (res) => {
//         let { errno=0, data={}, msg='' } = res;
//         if (data.status == 1) { //跳转成功
//         }
//         if (data.status == 2) { //h5回来不执行
//         }
//     }
// });
export const forward_h5 = (req) => {
    hybrid({
        tagname : "forward",
        param: req.param,
        callback: (res) => {
            req.callback(formatRes(res));
        }
    });
};
/*
todata: {
    fromPage: '',
    productId: 0,
    showPayType: false
}
*/
export const forward_mine_wallet_rechargecenter = (req) => {
    hybrid({
        tagname: "forward",
        param: {
            totype: "native",
            topage: "mine/wallet/rechargecenter",
            todata: req.data
        },
        callback: res => {
            req.callback(formatRes2(res));
        }
    });
};
/*
todata: {
    "fromPage": this.req.trigger_page, //埋点时的来源英文名称，MemberFeature（会员权益页面）
    "productId": this.h_data_goodinfo.id,//调起开通页选择的档位id, 默认传0够选第一个
    "showPayType": true, //是否默认调起支持选择框 或 是否直接购买（应该理解为是否自动帮用户点击购买）
    "nonIapSupported": this.j_native.is_jailbroken_phone, //是否支持越狱支付true支持 false不支持
}
*/
export const forward_load_open_member = (req) => {
    hybrid({
        tagname: "forward",
        param: {
            totype: "native",
            topage: "load_open_member",
            todata: req.data
        },
        callback: res => {
            req.callback(formatRes2(res));
        }
    });
};






// WEBPACK FOOTER //
// ./src/assets/js/common/hybrid/kkhybrid.js